import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Edit = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M11 4H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 5.52 4 6.08 4 7.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.52 20 6.08 20 7.2 20h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 18.48 20 17.92 20 16.8V13m-11-.586V15h2.586a1 1 0 0 0 .707-.293l8.043-8.043a2 2 0 0 0 0-2.828l-.172-.172a2 2 0 0 0-2.828 0l-8.043 8.043a1 1 0 0 0-.293.707'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.695 3.134a2.75 2.75 0 0 0-3.89 0l-8.042 8.043a1.75 1.75 0 0 0-.513 1.237V15c0 .414.336.75.75.75h2.586a1.75 1.75 0 0 0 1.237-.512l8.043-8.043a2.75 2.75 0 0 0 0-3.89zM11.75 4a.75.75 0 0 0-.75-.75H7.17c-.535 0-.98 0-1.345.03-.38.031-.736.098-1.073.27A2.75 2.75 0 0 0 3.55 4.752c-.172.337-.24.694-.27 1.074-.03.364-.03.81-.03 1.344v9.66c0 .535 0 .98.03 1.345.03.38.098.736.27 1.074a2.75 2.75 0 0 0 1.202 1.202c.337.171.693.238 1.073.27.365.03.81.03 1.345.03h9.66c.535 0 .98 0 1.345-.03.38-.032.736-.099 1.073-.27a2.75 2.75 0 0 0 1.202-1.202c.172-.338.24-.694.27-1.074.03-.364.03-.81.03-1.344V13a.75.75 0 0 0-1.5 0v3.8c0 .572 0 .956-.025 1.252-.023.287-.065.424-.111.515a1.25 1.25 0 0 1-.547.546c-.09.046-.227.088-.515.111-.295.025-.68.025-1.252.025H7.2c-.572 0-.957 0-1.253-.025-.287-.023-.424-.065-.514-.111a1.25 1.25 0 0 1-.547-.546c-.046-.09-.088-.228-.111-.515-.024-.296-.025-.68-.025-1.253V7.2c0-.572 0-.956.025-1.252.023-.287.065-.425.111-.515a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025H11a.75.75 0 0 0 .75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
